import { usePerformance, useNetworkPerformance } from '../hooks/usePerformance'

interface PerformanceMonitorProps {
  show?: boolean
}

export default function PerformanceMonitor({ show = false }: PerformanceMonitorProps) {
  const { metrics, isSupported } = usePerformance()
  const connection = useNetworkPerformance()

  if (!show || !isSupported || !metrics) {
    return null
  }

  return (
    <div className="fixed bottom-4 right-4 bg-black bg-opacity-80 text-white p-3 rounded-lg text-xs max-w-xs z-50">
      <h4 className="font-bold mb-2">Performance Metrics</h4>
      <div className="space-y-1">
        <div>Load Time: {metrics.loadTime.toFixed(2)}ms</div>
        <div>FCP: {metrics.firstContentfulPaint.toFixed(2)}ms</div>
        <div>LCP: {metrics.largestContentfulPaint.toFixed(2)}ms</div>
        <div>FID: {metrics.firstInputDelay.toFixed(2)}ms</div>
        <div>CLS: {metrics.cumulativeLayoutShift.toFixed(3)}</div>
        {connection && (
          <>
            <div>Network: {connection.effectiveType}</div>
            <div>Speed: {connection.downlink}Mbps</div>
            <div>RTT: {connection.rtt}ms</div>
          </>
        )}
      </div>
    </div>
  )
}
